import {useEffect, useId, useState} from "react";
import {ThinCloseIcon, TomansIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";

export const StudentMaxPayPerDayEditModal = (props:{active:boolean,closeHandler:any,onDone:any,currentMax:number,employeeId:string}) => {
    const [max,setMax] = useState(0);
    useEffect(() => {
        const isActive = props.active;
        const _max = props.currentMax;
        if(isActive){
            document.body.classList.add('body-no-scroll');
            setMax(_max);
        } else
            document.body.classList.remove('body-no-scroll');
    }, [props.active,props.currentMax]);
    const maxId = useId();
    const saveMax = () => {
        const _max = max;
        const _id = props.employeeId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/point/edit-max',
            {
                id:_id,
                m:_max,
            },
            true,
            (d:any)=>{
                HideProgressLoading();
                ShowSnackbar(
                    'حداکثر خرید روزانه از فروشگاه تغییر یافت.',
                    'باشه',
                    5000,
                );
                props.onDone(_max);
                props.closeHandler();
            },
            ()=>{
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active':'')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active':'')}>
                <div className="web-modal-header">
                    <div>
                        <b>ویرایش حداکثر خرید روزانه</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="setting-store-max">
                        <label htmlFor={maxId} className="f-roboto">
                            حداکثر مبلغ قابل برداشت توسط دانش‌آموز در روز:
                        </label>
                        <div className="toman-input">
                            <input type="number" className="form-control f-roboto"
                                   id={maxId}
                                   step={500}
                                   min={0}
                                   value={max}
                                   onChange={e=>{
                                       const t = e.currentTarget.value;
                                       setMax(parseInt(t));
                                   }}
                            />
                            <em><TomansIcon/></em>
                        </div>
                        <span>برای عدم اعمال محدودیت مبلغ را صفر وارد کنید.</span>
                        <div className="d-flex justify-content-end" style={{marginTop:20}}>
                            <button className="btn-pay" onClick={saveMax}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};